import React, { Component, PropTypes } from 'react';
import { HoverColor } from '../../../widgets/index';

const PreviewLink = ({ fontData, colorData, text, icon, className }) => {
    return (
        <div className={className}>
            <HoverColor color={colorData.hoverColor} />
            <span className={icon}>
                <a
                    className="active-hover"
                    href="#"
                    style={{
                        fontFamily: fontData.font,
                        textAlign: fontData.align,
                        lineHeight: fontData.lineHeight,
                        textDecoration: fontData.decoration,
                        fontStyle: fontData.style,
                        color: colorData.color,
                        hoverColor: colorData.hoverColor,
                        fontWeight: fontData.weight,
                        fontSize: fontData.size
                    }}
                >
                    {text}
                </a>
            </span>
        </div>
    );
};

PreviewLink.propTypes = {
    fontData: PropTypes.object,
    text: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string
};

export default PreviewLink;



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/PreviewLink.js